import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

import IconButton from '~/components/core/Atomic/Buttons/IconButton';
import CircularProgress from '~/components/core/Atomic/CircularProgress/CircularProgress';
import Typography from '~/components/core/Atomic/Typography';
import { EyeIcon } from '~/components/icons';

import { reportAxiosError } from '../../../../../../../../Utils';
import { useSysconfig } from '../../../../../../SystemConfigurationScreen';

import { colorPalette, useStyles } from '../../../../../../../../assets/styles';
import styles from '../../vendorApiProfile.module.scss';

const SECRET_LENGTH = 70;

const Secret = ({ vendorApiProfileId, getSecret }) => {
  const { classes } = useStyles();
  const { organization } = useSysconfig();
  const [isSecretLoading, setSecretLoading] = useState(false);
  const [isSecretDisplay, setSecretDisplay] = useState(false);
  const secretRef = useRef();

  const secretText = isSecretDisplay ? secretRef.current : '• '.repeat(SECRET_LENGTH);

  const onGetSecret = async () => {
    try {
      if (!secretRef.current) {
        setSecretLoading(true);

        const { data } = await axios.get(getSecret(organization, vendorApiProfileId));
        secretRef.current = data;
      }
      setSecretLoading(false);
      setSecretDisplay(!isSecretDisplay);

      return secretRef.current;
    } catch (error) {
      await reportAxiosError(error);
    }
    setSecretLoading(false);
  };

  return (
    <div className={styles.secretContainer}>
      {isSecretLoading ? (
        <CircularProgress size={20} className={classes.inlineEditIcon} />
      ) : (
        <>
          <Typography variant="body1">{secretText}</Typography>
          <IconButton className={classes.tableActionsIcon} onClick={onGetSecret}>
            <EyeIcon iconColor={isSecretDisplay && colorPalette.status.canceled} />
          </IconButton>
        </>
      )}
    </div>
  );
};

Secret.propTypes = {
  vendorApiProfileId: PropTypes.number,
  getSecret: PropTypes.func.isRequired,
};

export default Secret;
